<template>
  <span
    v-if="count > 0"
    class="kt-badge tab-count-badge"
    :class="{
      'kt-badge--primary': type === 'primary',
      'kt-badge--secondary': type === 'secondary',
    }"
    v-text="countText"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  type?: 'primary' | 'secondary';
  count: number;
}>(), {
  type: 'primary',
})

const countText = computed(() => {
  return props.count > 9 ? '9+' : props.count
})
</script>

<style scoped lang="scss">
.kt-badge.kt-badge--primary.tab-count-badge,
.kt-badge.kt-badge--secondary.tab-count-badge {
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  width: 1.5rem !important;
  height: 1.5rem !important;

  left: unset !important;
  right: 0 !important;
  margin-bottom: 15px;
}
</style>
